import { render, staticRenderFns } from "./UserInfoLegacy.vue?vue&type=template&id=6c42d2a4&"
import script from "./UserInfoLegacy.vue?vue&type=script&lang=js&"
export * from "./UserInfoLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports